"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadInput = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var button_1 = require("../../action/button");
var UploadInput = /** @class */function (_super) {
  __extends(UploadInput, _super);
  function UploadInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.imageInput = (0, react_1.createRef)();
    _this.state = {
      error: ""
    };
    _this.setAsyncState = function (newState) {
      return new Promise(function (resolve) {
        return _this.setState(newState, resolve);
      });
    };
    _this.handleSubmit = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var error, fileSize, maxFileSize;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              error = "";
              if (!this.props.optional) {
                if (this.props.file) {
                  fileSize = this.props.file.size / 1024 / 1024;
                  maxFileSize = this.props.maxFileSize ? this.props.maxFileSize : 30;
                  if (fileSize > maxFileSize) {
                    error = "File size cannot exceed ".concat(maxFileSize, "MB");
                  }
                } else {
                  error = "Please upload a file";
                }
              }
              return [4 /*yield*/, this.setAsyncState({
                error: error
              })];
            case 1:
              _a.sent();
              return [2 /*return*/, error ? false : true];
          }
        });
      });
    };
    _this.handleOnChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };
    _this.renderFileDescription = function () {
      if (_this.props.fileDescription) {
        return _this.props.fileDescription;
      } else {
        return "PNG, JPG, JPEG, TIFF up to 30MB";
      }
    };
    _this.renderUploadContent = function () {
      if (typeof _this.props.file === "string" && _this.props.file.length > 0) {
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
          className: "relative py-2"
        }, !_this.props.hidePreview && react_1.default.createElement("img", {
          src: _this.props.file,
          alt: "preview.png",
          className: "mx-auto h-32 w-auto max-w-40 object-cover"
        }), !_this.props.disabled && react_1.default.createElement(button_1.Button, {
          type: "light",
          size: "small",
          text: "Update",
          onClick: function () {
            _this.imageInput.current.click();
          },
          className: "absolute top-0 bottom-0 left-0 right-0 mx-auto my-auto w-24 h-10"
        })), react_1.default.createElement("input", {
          ref: _this.imageInput,
          id: _this.props.id,
          name: "file-upload",
          type: "file",
          className: "sr-only",
          accept: _this.props.accept,
          onChange: _this.handleOnChange
        }));
      } else {
        return react_1.default.createElement("div", {
          className: "space-y-1 text-center"
        }, _this.props.file instanceof File && !_this.props.hidePreview ? react_1.default.createElement("img", {
          alt: "",
          src: URL.createObjectURL(_this.props.file),
          className: "mx-auto h-32 w-auto max-w-40 object-cover"
        }) : react_1.default.createElement(outline_1.FolderPlusIcon, {
          className: "mx-auto h-12 w-12 text-gray-300"
        }), react_1.default.createElement("div", {
          className: "flex text-sm text-gray-600 justify-center"
        }, react_1.default.createElement("label", {
          className: "relative cursor-pointer bg-white rounded-md font-medium ".concat(_this.props.disabled ? "text-gray-600" : "text-primary-600 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500")
        }, react_1.default.createElement("span", null, "Upload file"), react_1.default.createElement("input", {
          id: _this.props.id,
          name: "file-upload",
          type: "file",
          className: "sr-only",
          accept: _this.props.accept,
          disabled: _this.props.disabled,
          onChange: _this.handleOnChange
        }))), react_1.default.createElement("p", {
          className: "text-xs text-gray-500"
        }, _this.props.file ? "".concat(_this.props.file.name) : _this.renderFileDescription()));
      }
    };
    return _this;
  }
  UploadInput.prototype.render = function () {
    var defaultBorderColor = "border-gray-300";
    var errorBorderColor = "border-red-300";
    return react_1.default.createElement("div", {
      className: this.props.className
    }, react_1.default.createElement("label", {
      className: "block text-sm font-medium text-gray-700"
    }, this.props.label), react_1.default.createElement("div", {
      className: "".concat(this.state.error ? errorBorderColor : defaultBorderColor, " mt-1 border-2 justify-center px-6 pt-5 pb-6 border-dashed rounded-md")
    }, this.renderUploadContent()), react_1.default.createElement("span", {
      className: "text-red-500 text-sm"
    }, this.state.error));
  };
  return UploadInput;
}(react_1.Component);
exports.UploadInput = UploadInput;